// Token Renewal Actions
export const RENEW_TOKEN_REQUEST = 'RENEW_TOKEN_REQUEST';
export const RENEW_TOKEN_SUCCESS = 'RENEW_TOKEN_SUCCESS';
export const RENEW_TOKEN_FAILURE = 'RENEW_TOKEN_FAILURE';
export const CLEAR_RENEWAL_ERROR = 'CLEAR_RENEWAL_ERROR';

// Action Creators
export const requestTokenRenewal = (currentToken, refreshToken = null) => ({
  type: RENEW_TOKEN_REQUEST,
  payload: { currentToken, refreshToken }
});

export const tokenRenewalSuccess = (newToken, newExpiresAt, renewedAt) => ({
  type: RENEW_TOKEN_SUCCESS,
  payload: { newToken, newExpiresAt, renewedAt }
});

export const tokenRenewalFailure = (error, failedAt) => ({
  type: RENEW_TOKEN_FAILURE,
  payload: { error, failedAt }
});

export const clearRenewalError = () => ({
  type: CLEAR_RENEWAL_ERROR
});
